// extracted by mini-css-extract-plugin
export var buttonContainer = "_3m-6";
export var centeredToolbar = "_3m-4";
export var dashdraw = "_3m-c";
export var emptyStateContainer = "_3m-8";
export var emptyStateText = "_3m-9";
export var flowEditor = "_3m-0";
export var flowEditorContainer = "_3m-7";
export var hovered = "_3m-1";
export var leftPanel = "_3m-3";
export var mainCanvasContainer = "_3m-a";
export var minimap = "_3m-b";
export var selectMode = "_3m-2";
export var toolbarSeparator = "_3m-5";